export var createTooltipDriver = function (wrapper, global) {
    var tooltipBase = global.$('.tooltip-trigger .tooltip');
    var tooltipTriggerBase = wrapper.$('.tooltip-trigger .popper-target');
    var tooltipBody = global.$('.tooltip .tooltip-body');
    return {
        isDarkTheme: function () { return tooltipBase.hasClass('dark-theme-tooltip'); },
        isLightTheme: function () { return tooltipBase.hasClass('light-theme-tooltip'); },
        tooltipBody: tooltipBody,
        tooltipBase: tooltipBase,
        tooltipTriggerBase: tooltipTriggerBase
    };
};
//# sourceMappingURL=driver.js.map